<h1 color="secondary">Resources</h1>
<mat-card appearance="outlined">
    <mat-tab-group *ngIf="learningResource?.length > 0" (selectedTabChange)="onTabChange()">
        <mat-tab label="YOUR TOP RESOURCES" aria-label="Your top resources">
            <ng-template matTabContent>
                <h2>Your Top Resources</h2>
                <p>
                    Listed below are the top suggested resources, based on the information you included in your current
                    CPD plan. These resources are for your information and reference only, and they are not the only
                    resources that should be considered when implementing your plan. The Law Society of Alberta is not
                    responsible for the accuracy, content or information contained in these sites. Views expressed in
                    these resources are the views of the authors individually and do not necessarily reflect the view of
                    the Law Society.
                </p>
                <mat-card appearance="outlined" *ngFor="let resource of topLearningResource; let i = index">
                    <div class="mat-card-header">
                        <h3><a (click)="onPageLaunch()" target="_blank" *ngIf="resource.Url"
                                [href]="getUrl(resource.Url)">{{resource.Name}} (opens new
                                window)</a><span class="no-url" *ngIf="!resource.Url">{{resource.Name}}</span></h3>
                        <div class="pill">{{resource.Cost}}</div>
                    </div>
                    <mat-card-content>
                        <label [for]="'authorg'+resource.Id" class="label">Author/Organization</label>
                        <p [id]="'authorg'+resource.Id" class="content"
                            [attr.aria-describedby]="'resourceheader'+resource.Id">{{resource.AuthorOrganization ?? ''}}</p>
                        <label [for]="'comp'+resource.Id" class="label">Competency</label>
                        <p [id]="'comp'+resource.Id" class="content" [attr.aria-describedby]="'resourceheader'+resource.Id">{{resource.Competency ?? ''}}</p>
                        <label [for]="'formats'+resource.Id" class="label">Format <button type="button"
                                class="material-symbols-outlined bulb" [attr.aria-label]="'format information dialog for ' + resource.Name"
                                (click)="launchFormatDialog()">info</button></label>
                        <p [id]="'formats'+resource.Id" class="content" [attr.aria-describedby]="'resourceheader'+resource.Id">{{resource.Formats ?? ''}}</p>
                        <label [for]="'desc'+resource.Id" class="label">Description</label>
                        <p [id]="'desc'+resource.Id" class="content" [attr.aria-describedby]="'resourceheader'+resource.Id">{{resource.Description ?? ''}}</p>
                    </mat-card-content>
                </mat-card>
            </ng-template>
        </mat-tab>
        <mat-tab label="ALL RESOURCES">
            <ng-template matTabContent>
                <mat-drawer-container class="drawer-container">
                    <mat-drawer class="drawer" id="filters" #drawer position="end" autoFocus="true"
                        (openedChange)="onOpenFilter($event)">
                        <div class="drawer-content">
                            <div class="drawer-title">
                                <h2 class="filters-title">Filters</h2>
                                <button id="closebutton" aria-label="close filter options" type="button"
                                    (click)="drawer.toggle()">CLOSE <span class="material-symbols-outlined cancel-icon">
                                    cancel
                                    </span>
                                </button>
                            </div>

                            <div class="content">
                                <fieldset>
                                    <legend><h3>Cost</h3></legend>
                                    <mat-checkbox disableRipple="true" *ngFor="let cost of filter.CostItems"
                                        [(ngModel)]="cost.checked">{{cost.name}}</mat-checkbox>
                                </fieldset>
                                <fieldset>
                                    <legend><h3>Format</h3></legend>
                                    <mat-checkbox disableRipple="true" *ngFor="let format of filter.FormatItems"
                                        [(ngModel)]="format.checked">{{format.name}}</mat-checkbox>
                                </fieldset>
                                <fieldset>
                                    <legend><h3>Competencies</h3></legend>
                                    <app-collapsible-panel *ngFor="let item of filter.DomainItems"
                                    [domain]="item"></app-collapsible-panel>
                                </fieldset>
                            </div>
                            <button color="white" class="resetfilter" mat-raised-button type="button"
                                    (click)="resetFilters()">RESET</button>
                        </div>
                    </mat-drawer>
                    <mat-drawer-content>
                        <h2>All Resources</h2>
                        <p>
                            Listed below are resources that may be of interest to you in implementing your CPD plan. You
                            can use the filtering options to narrow the list to specific competencies, formats
                            or keywords. These resources are for your information and reference only, and they are not
                            the only resources that should be considered when carrying out your plan. The Law Society of
                            Alberta is not responsible for the accuracy, content or information contained in these
                            sites. Views expressed in these resources are the views of the authors individually and do
                            not necessarily reflect the view of the Law Society.
                        </p>
                        <mat-form-field floatLabel="always" appearance="outline">
                            <mat-label for="searchbar" id="searchlabel">Search by name or keywords</mat-label>
                            <input [(ngModel)]="search" id="searchbar" matInput (keydown)="resetPage()">
                        </mat-form-field>
                        <mat-form-field floatLabel="always" appearance="outline">
                            <mat-label aria-hidden="true">Sort</mat-label>
                            <mat-select id="sortbar" aria-label="Sort" [(ngModel)]="sort">
                                <mat-option value="recent">Recent</mat-option>
                                <mat-option value="name">Name</mat-option>
                                <mat-option value="org">Author/Organization</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <button type="button" aria-label="open filter options" class="filterbutton"
                            (click)="drawer.toggle()"><span class="material-symbols-outlined">filter_list</span>
                            FILTERS</button>
                        <app-expandable-chips [filter]="filter" [drawer]="drawer"></app-expandable-chips>
                        <div aria-live="assertive">
                            <div *ngIf="(learningResource | learningResourcesSort: sort | learningResourcesSearch: search | learningResourcesFilter: filter | PaginationFilter: defaultRecords:pageIndex)?.length === 0"
                                role="alert">There are currently no resources matching that criteria.</div>
                        </div>
                        <mat-card
                            appearance="outlined"
                            *ngFor="let resource of learningResource | learningResourcesSort: sort | learningResourcesSearch: search | learningResourcesFilter: filter | PaginationFilter: defaultRecords:pageIndex; let i = index">
                            <div class="mat-card-header" [id]="'resourceheader'+resource.Id">
                                <h3><a (click)="onPageLaunch()" target="_blank" *ngIf="resource.Url"
                                        [href]="getUrl(resource.Url)">{{resource.Name}}
                                        (opens new window)</a><span class="no-url"
                                        *ngIf="!resource.Url">{{resource.Name}}</span></h3>
                                <div class="pill">{{resource.Cost}}</div>
                            </div>
                            <mat-card-content>
                                <label [for]="'authorg'+resource.Id" class="label">Author/Organization</label>
                                <p [id]="'authorg'+resource.Id" class="content"[attr.aria-describedby]="'resourceheader'+resource.Id">{{resource.AuthorOrganization ?? ''}}</p>
                                <label [for]="'comp'+resource.Id" class="label">Competency</label>
                                <p [id]="'comp'+resource.Id" class="content" [attr.aria-describedby]="'resourceheader'+resource.Id">{{resource.Competency ?? ''}}</p>
                                <label [for]="'formats'+resource.Id" class="label">Format <button type="button"
                                        class="material-symbols-outlined bulb" [attr.aria-label]="'format information dialog for ' + resource.Name"
                                        (click)="launchFormatDialog()">info</button></label>
                                <p [id]="'formats'+resource.Id" class="content" [attr.aria-describedby]="'resourceheader'+resource.Id">{{resource.Formats ?? ''}}</p>
                                <label [for]="'desc'+resource.Id" class="label">Description</label>
                                <p [id]="'desc'+resource.Id" class="content" [attr.aria-describedby]="'resourceheader'+resource.Id">{{resource.Description ?? ''}}</p>
                            </mat-card-content>
                        </mat-card>
                        <mat-paginator
                            [length]="(learningResource | learningResourcesSort: sort | learningResourcesSearch: search | learningResourcesFilter: filter)?.length"
                            [pageSize]="defaultRecords" [showFirstLastButtons]="true" aria-label="Select page"
                            (page)="onPageChange($event)">
                        </mat-paginator>
                    </mat-drawer-content>
                </mat-drawer-container>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</mat-card>
